import { TabsPelican } from './component';

export * from './component';
export default TabsPelican;
